import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";

const UpsellProductModal = ({ open, onClose, upsellDetails }) => {
  if (!upsellDetails) return null;

  const rows = (upsellDetails.concessions || []).map(item => ({
    id: item.id,
    product: {
      image: item.image?.props?.src || "",
      name: item.name
    },
    clicks: item.clicks || 0,
    purchased: item.purchases || 0
  }));

  const columns = [
    {
      field: "product",
      headerName: "Upsell Product",
      width: 300,
      renderCell: params => (
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}
        >
          <img
            src={params?.value?.image || ""}
            alt={params?.value?.name || "Upsell Product"}
            style={{
              width: 50,
              height: 50,
              marginRight: 12,
              objectFit: "cover"
            }}
          />
          <span style={{ fontWeight: "400" }}>
            {params?.value?.name || "Upsell Product"}
          </span>
        </div>
      )
    },
    {
      field: "clicks",
      headerName: "Clicks",
      width: 120,
      renderHeader: params => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          }}
        >
          <span style={{ fontWeight: "500" }}>{params.colDef.headerName}</span>
        </div>
      ),
      renderCell: params => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <span style={{ fontWeight: "400" }}>{params.value}</span>
          </div>
        );
      }
    },
    {
      field: "purchased",
      headerName: "Purchased",
      width: 120,
      renderHeader: params => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          }}
        >
          <span style={{ fontWeight: "500" }}>{params.colDef.headerName}</span>
        </div>
      ),
      renderCell: params => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <span style={{ fontWeight: "400" }}>{params.value}</span>
          </div>
        );
      }
    }
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="upsell-product-modal"
    >
      <DialogTitle className="upsell-product-modal-title">
        Upsell Product
      </DialogTitle>
      <DialogContent className="upsell-modal-content">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            backgroundColor: "#16161A",
            padding: "24px",
            width: "fit-content"
          }}
        >
          <img
            src={upsellDetails?.movie?.image}
            alt={upsellDetails?.movie?.name || "Upsell Product"}
            style={{
              width: 84,
              height: 47,
              marginRight: 12,
              objectFit: "cover"
            }}
          />
          <span style={{ fontWeight: "400", fontSize: "18px" }}>
            {upsellDetails?.movie?.name || "Upsell Product"}
          </span>
        </div>

        <div style={{ height: "70vh", width: "100%", marginTop: "20px" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowHeight={72}
            headerHeight={60}
            disableColumnMenu
            autoHeight
          />
        </div>
      </DialogContent>
      <DialogActions className="upsell-modal-actions">
        <Button onClick={onClose} color="primary" variant="text">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpsellProductModal;
